import { render, staticRenderFns } from "./edit-point.vue?vue&type=template&id=130b5949&scoped=true&"
import script from "./edit-point.vue?vue&type=script&lang=js&"
export * from "./edit-point.vue?vue&type=script&lang=js&"
import style0 from "./edit-point.vue?vue&type=style&index=0&id=130b5949&lang=scss&scoped=true&"
import style1 from "./edit-point.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130b5949",
  null
  
)

export default component.exports